import { ScheduleAreasProvider } from './ScheduleAreasContext';
import { ScheduleUnitProvider } from './ScheduleUnitContext';

export * from './DateAndTimeContext';
export * from './ScheduleAreasContext';
export * from './ScheduleUnitContext';

export const SchedulesLocalProvider: React.FC = ({ children }) => (
  <ScheduleAreasProvider>
    <ScheduleUnitProvider>{children}</ScheduleUnitProvider>
  </ScheduleAreasProvider>
);
